module.exports = __webpack_public_path__ + "media/images/sale_crm/user_settings-b25729fd00e9275b4f24453ad682cfbb.svg";